import * as Yup from "yup";

export const VendorSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
});
